// AEST formatting (fixed UTC+10, no DST).
// Date.prototype.getTime() is already an absolute UTC epoch - to display in
// AEST we shift forward by 10h and then read the .getUTC*() parts. We must
// NOT mix in the browser's local getTimezoneOffset() (doing so makes the
// display correct only when the browser happens to be in UTC).
const AEST_OFFSET_MIN = 10 * 60;

function toAest(d) {
  return new Date(d.getTime() + AEST_OFFSET_MIN * 60000);
}

const MONTHS = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];

export function fmtAestDateTime(iso) {
  if (!iso) return "";
  try {
    const d = toAest(new Date(iso));
    const dd = String(d.getUTCDate()).padStart(2, "0");
    const m = MONTHS[d.getUTCMonth()];
    const y = d.getUTCFullYear();
    const hh = String(d.getUTCHours()).padStart(2, "0");
    const mm = String(d.getUTCMinutes()).padStart(2, "0");
    return `${dd} ${m} ${y} ${hh}:${mm}`;
  } catch { return iso; }
}

export function fmtAestDate(iso) {
  if (!iso) return "";
  try {
    const d = typeof iso === "string" && iso.length === 10
      ? new Date(iso + "T00:00:00Z")
      : toAest(new Date(iso));
    const dd = String(d.getUTCDate()).padStart(2, "0");
    const m = MONTHS[d.getUTCMonth()];
    return `${dd} ${m} ${d.getUTCFullYear()}`;
  } catch { return iso; }
}

/** Returns today's date in AEST as a YYYY-MM-DD string (for <input type="date"> defaults). */
export function todayAestISO() {
  const d = toAest(new Date());
  const y = d.getUTCFullYear();
  const m = String(d.getUTCMonth() + 1).padStart(2, "0");
  const dd = String(d.getUTCDate()).padStart(2, "0");
  return `${y}-${m}-${dd}`;
}

/** Adds N days to today (AEST) and returns YYYY-MM-DD. */
export function addDaysAestISO(days) {
  const d = toAest(new Date());
  d.setUTCDate(d.getUTCDate() + days);
  const y = d.getUTCFullYear();
  const m = String(d.getUTCMonth() + 1).padStart(2, "0");
  const dd = String(d.getUTCDate()).padStart(2, "0");
  return `${y}-${m}-${dd}`;
}

export function fmtAud(n) {
  if (n == null || n === "") return "";
  const v = Number(n);
  if (isNaN(v)) return String(n);
  return "$" + v.toLocaleString("en-AU", { maximumFractionDigits: 0 });
}

export function fmtPhone(raw, defaultCc = "+61") {
  if (!raw) return "";
  const s = String(raw).replace(/[^\d+]/g, "");
  if (!s) return "";
  if (s.startsWith("+")) {
    const m = s.match(/^\+(\d{1,3})(\d*)$/);
    if (m) return `(+${m[1]}) ${m[2].replace(/^0+/, "")}`;
    return raw;
  }
  if (s.startsWith("0")) return `(${defaultCc}) ${s.replace(/^0+/, "")}`;
  return `(${defaultCc}) ${s}`;
}

export function telHref(raw) {
  if (!raw) return "";
  const s = String(raw).replace(/[^\d+]/g, "");
  if (s.startsWith("+")) return `tel:${s}`;
  if (s.startsWith("0")) return `tel:+61${s.slice(1)}`;
  return `tel:${s}`;
}

export function mapsHref(parts) {
  const addr = parts.filter(Boolean).join(", ");
  if (!addr) return "";
  return `https://maps.google.com/?q=${encodeURIComponent(addr)}`;
}

export function segmentsTheme(segments) {
  if (!segments || segments.length === 0) return "default";
  const hasM = segments.includes("M");
  const hasOther = segments.some(s => s !== "M");
  if (hasM && hasOther) return "both";
  if (hasM) return "mixer";
  return "drill";
}
